// Через сколько после окончания ввода текст переносится в другие решения
export const TEXT_SYNC_DELAY_MS = 1000;

// В чём лежит копия нарушения, позже сюда добавится акт
export type ViolationCopyOwnerType = 'decision';

export interface IViolationCopiesContainer {
  ownerType: ViolationCopyOwnerType;
  decisionsPath: string;
  requirementsKey: string;
}

// Где в формах КНМ, ПМ и ПР лежат копии одного и того же нарушения
export const VIOLATION_COPIES_CONTAINERS: IViolationCopiesContainer[] = [
  { ownerType: 'decision', decisionsPath: 'resultDecisions', requirementsKey: 'violatedMandatoryRequirements' },
  { ownerType: 'decision', decisionsPath: 'pmResultDecisions', requirementsKey: 'violatedMandatoryRequirements' },
  {
    ownerType: 'decision',
    decisionsPath: 'organization.resultDecisions',
    requirementsKey: 'eliminatedMandatoryRequirements',
  },
];

// Пока синкаем только между решениями, акт - решение пока не трогаем
export const SYNC_DIRECTIONS: { from: ViolationCopyOwnerType; to: ViolationCopyOwnerType }[] = [
  { from: 'decision', to: 'decision' },
];

/**
 * При изменении любого поля группы сверяются все её поля, а в другие решения пишутся только отличающиеся.
 * Нужно, чтобы связанные поля не разъехались по времени, к примеру бек не примет corrected без eliminationViolations,
 * а isAppealed сбрасывается, если в fixes нет отрицательной оценки.
 */
export const SYNC_GROUPS: Record<string, string[]> = {
  fixFact: [
    'isFixed',
    'fixes',
    'fixFactMethod',
    'fixFactDate',
    'isViolationResolved',
    'isViolationResolvedNote',
    'includeInSubject',
    'isAppealed',
    'explanation',
    'explanationReactQuillEditor',
  ],
  fixPlan: ['fixPlanDates', 'fixPlanMethods', 'fixPlanExplanations'],
  repeatCheck: ['repeatCorrected', 'repeatCorrectedInEvent', 'repeatExplanation'],
};

// Текстовые поля нарушения, переносятся по таймеру или при потере фокуса
export const TEXT_FIELDS: string[] = [
  'explanation',
  'explanationReactQuillEditor',
  'isViolationResolvedNote',
  'repeatExplanation',
];

// Текстовые поля внутри элементов массивов нарушения
export const ARRAY_ITEM_TEXT_FIELDS: Record<string, string[]> = {
  fixes: ['explanationMaterial', 'explanationMaterialReactQuillEditor', 'explanationGrade'],
  fixPlanExplanations: ['value', 'valueReactQuillEditor'],
};
